<app-dossier-bien-label-price [dossierBien]="dossierBien" [options]="{showNV: false}"></app-dossier-bien-label-price>

<app-dossier-bien-pricing [dossierBien]="dossierBien"></app-dossier-bien-pricing>
